import { render, staticRenderFns } from "./LimitedTimeActivity.vue?vue&type=template&id=1631b226&scoped=true&"
import script from "./LimitedTimeActivity.vue?vue&type=script&lang=js&"
export * from "./LimitedTimeActivity.vue?vue&type=script&lang=js&"
import style0 from "./LimitedTimeActivity.vue?vue&type=style&index=0&id=1631b226&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1631b226",
  null
  
)

export default component.exports